import { Store } from "@/revamp/store/store";
import clone from "just-clone";

class NotifyStore extends Store {
  data() {
    return {
      messageQueue: [],
    };
  }

  createModal(title, body, options, isCover) {
    this.sendMessage({ target: "modal", title, body, options, isCover });
  }

  sendMessage(message) {
    this.state.messageQueue.push(message);
  }

  readMessage() {
    if (this.state.messageQueue.length == 0) return null;
    return clone(this.state.messageQueue[0]);
  }

  deQueue() {
    this.state.messageQueue.shift();
  }
}

export const notifyStore = new NotifyStore("notify-store");
